import RegionStagesAPI from "@/api/RegionStagesAPI";
import {idUserForApi} from "@/controllers/UserController";

class RegionStageController {
  constructor() {
    this.api = RegionStagesAPI;
  }

  _checkId(id) {
    if (!id)
      throw new Error('id cannot be null');
  }

  /**
   * @param {Number} uslId
   * @param {1 | 2 | 3} foId
   * @param { Number | null | undefined } [regionId]
   * */
  async getDataStage(uslId, foId = 1, regionId) {
    try {
      regionId = regionId ?? idUserForApi(regionId);
      this._checkId(regionId);
      const res = await this.api.getDataStage(uslId, foId, regionId);
      return res.data
    } catch (e) {
      console.error('error getDataStage ' + e.message)
      throw new Error('error getDataStage ' + e.message)
    }
  }

  /**
   *  @param {Number} rowId
   *  @param { 1 | 2 | 3 } stageId
   *  @param {Number} value
   *  @param {string} textVal
   * */
  async saveData(rowId = 0, stageId = 2, value = 0, textVal = '') {
    let fd = new FormData();
    fd.append('rowId', String(rowId));
    fd.append('stageId', String(stageId));
    fd.append('newValue', String(value));
    fd.append('comment', textVal);
    try {
      if (!rowId || !value)
        throw new Error('rowId && value invalid; cannot be null');
      const res = await this.api.setDataById(fd);
      return res.data
    } catch (e) {
      console.error('error saveData ' + e.message)
      throw new Error('error saveData ' + e.message)
    }
  }
}

export default new RegionStageController();